module.exports = __webpack_public_path__ + "static/5-0ee8ec0975d628846cc9d5e71297a936.jpeg";